// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (max-width:768px){#soap-loading-menu[data-v-66f75e89],#soap-loading-menu-divider[data-v-66f75e89]{display:none}}#soap-loading-menu[data-v-66f75e89]{width:250px}#soap-loading-menu-divider[data-v-66f75e89]{width:30px}#soap-loading-content[data-v-66f75e89]{-webkit-box-flex:1;-ms-flex:1;flex:1}", ""]);
// Exports
module.exports = exports;
